export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const FETCH_ALL = "FETCH_ALL";
export const FETCH_USER_POSTS = "FETCH_USER_POSTS";
export const LOGIN = "LOGIN";
